(function defineUtilityFunctions($, window) {
    "use strict";

    var localStorageKeyPrefix = window.THEME.name + "." + getTldFromUrl() + ".";
    var storageKeyPrefix = localStorageKeyPrefix;
    var regExForbiddenInCSSClassNames = /[^_a-zA-Z0-9-]/gi;

    //Store data wrapper
    function storeData(key, value, storageType) {
        storageType = storageType || 'local';

        if (! window.Modernizr[storageType + 'storage']) {
            return false;
        }

        var storageSystem = window[storageType + 'Storage'];

        if (! storageSystem) {
            return false;
        }

        storageSystem[key] = value;
    }

    // Generate storage key
    function buildKey(key, prefix) {

        // add our tld
        key = storageKeyPrefix + key;

        if (prefix) {
            return prefix += key;
        }

        return key;
    }

    //Create JSON string for value and timestamp
    function createStampedFieldValue(value, timestamp) {
        return JSON.stringify({
            value : value,
            timestamp: timestamp
        });
    }


    function storeFormFieldValue($input, storageType, radioButtonId) {
        var prefix    = $input.data('storage-address-key');
        var timestamp = $input.data('storage-current-time');

        // if it's a radio button we need to delete the existing
        // entry (if any) first
        if (_.isString(radioButtonId)) {
            deleteRadioButtonGroupData(radioButtonId, storageType, prefix);
        }
        // Prepare key and vale
        var fieldVal = createStampedFieldValue($input.val(), timestamp);
        var key = buildKey($input.attr('id'), prefix);

        storeData(key, fieldVal, storageType);

    }

    var isSessionStorageOnly = function isSessionStorageOnly(key) {
        var sessionStorageOnly = [
            "Checkout_Payment_SofortBankingForm_onlineBankTransferAccountNumber",
            "Checkout_Payment_SofortBankingForm_onlineBankTransferBankCodeNumber",
            "Checkout_Payment_DebitForm_debitAccountNumber",
            "Checkout_Payment_DebitForm_debitBankCodeNumber",
            "Checkout_Payment_DebitForm_debitHolder"
        ];

        return $.inArray(key, sessionStorageOnly) > -1;
    };

    /*
        Radio button data must first be deleted whenever we want to localStore a
        new radio button value, because else we will have all radion butto values
        stored that have been clicked and not only the one currently "checked".
    */

    function deleteRadioButtonGroupData(id, storageType, prefix) {
        storageType = storageType || 'local';
        prefix      = prefix        || '';

        if (! window.Modernizr[storageType + 'storage']) {
            return false;
        }

        var storageSystem = window[storageType + 'Storage'];

        if (! storageSystem) {
            return false;
        }

        // legacy
        var $radioButton         = null;
        var radioButtonId        = null;
        var $oneRadioButton      = $("#" + id.replace(".", "\\."));
        var radioButtonGroupName = $oneRadioButton.attr("name");
        var $form                = $oneRadioButton.closest("form");
        var radioButtonsArr      = $form.find("input[name='" + radioButtonGroupName + "']");


        if (radioButtonsArr.length) {
            for (var i = radioButtonsArr.length; i--;) { // From length down to 0
                $radioButton  = $(radioButtonsArr[i]);
                radioButtonId = $radioButton.attr("id");
                storageSystem.removeItem(prefix + localStorageKeyPrefix + radioButtonId);
            }
        }
    }

    var lockElement = function lockElement($element) {
        if (typeof $element === "object") {
            $element.data("locked", true);
            $element.find(".lockedAnimation").removeClass("isHidden");
        }
    };

    var unlockElement = function unlockElement($element) {
        if (typeof $element === "object") {
            $element.data("locked", false);
            $element.find(".lockedAnimation").addClass("isHidden");
        }
    };

    var isLocked = function isLocked($element) {
        var locked = false;

        if (typeof $element === "object") {
            locked = ($element.data("locked") === true);
        }

        return locked;
    };

    var suppressDefaultEventFor = function suppressDefaultEventFor(event) {
        event.preventDefault();
        event.stopPropagation();
    };

    function getTldFromUrl() {
        var tld  = false;
        var temp = location.host.split(".").reverse();

        if (temp.length) {
            tld = temp[0];
        }

        return tld;
    };

    var cleanCSSClassName = function cleanCSSClassName(dirtyClassName) {
        var cleanClassName = dirtyClassName.replace(regExForbiddenInCSSClassNames, "_");

        return cleanClassName;
    };

    var replaceRadioButtonsWithImages = function replaceRadioButtonsWithImages($radioButtons) {
        // Hide radio buttons and instead use the <label>s that follow each radio button for handling
        // the display of the images (using CSS background) and the events:
        $radioButtons.next("label").addClass($radioButtons.attr("class"));
        $radioButtons.addClass("isHidden");
        $radioButtons.on("click", function handleReplacedRadioButtonClick() {
            window.THEME.$document.trigger("clickOnReplacedRadioButton", [$(this)]);
        });
    };

    var updateReplacedRadioButtonStates = function updateReplacedRadioButtonStates($replacedRadioButton) {
        var $formAffected      = $replacedRadioButton.closest("form");
        var $replacedButtons   = $formAffected.find(".radioButtonImage[type=radio]");

        $replacedButtons.each(function updateEachReplacedRadioButtonState() {
            var $eachButton = $(this);
            var $replacementLabel = $eachButton.next("label");

            if ($eachButton.prop("disabled")) {
                $replacementLabel.addClass("disabled").removeAttr("tabindex");
            } else {
                $replacementLabel.removeClass("disabled").attr("tabindex", 1);
            }

            if ($eachButton.prop("checked")) {
                $replacementLabel.addClass("active");
            } else {
                $replacementLabel.removeClass("active");
            }
        });
    };

    var oneTimeToggle = function oneTimeToggle($togglerElement, $toggleElements) {
        $togglerElement.addClass("isHidden");
        $toggleElements.removeClass("isHidden");
    };

    window.THEME.Utils = {
        cleanCSSClassName              : cleanCSSClassName,
        deleteRadioButtonGroupData     : deleteRadioButtonGroupData,
        getTldFromUrl                  : getTldFromUrl,
        isLocked                       : isLocked,
        lockElement                    : lockElement,
        oneTimeToggle                  : oneTimeToggle,
		isSessionStorageOnly           : isSessionStorageOnly,
        replaceRadioButtonsWithImages  : replaceRadioButtonsWithImages,
        storeData                      : storeData,
        storeFormFieldValue            : storeFormFieldValue,
        suppressDefaultEventFor        : suppressDefaultEventFor,
        unlockElement                  : unlockElement,
        updateReplacedRadioButtonStates: updateReplacedRadioButtonStates
    };

}(window.jQuery, window));
